import $ from 'jquery';

$(document).ready(function() {
    $('.js-slide-game').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 2.4,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
        {
            breakpoint: 1100,
            settings: {
                slidesToShow: 1.4,
                slidesToScroll: 1,
                arrows: true,
                dots: false
           }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1.8,
                slidesToScroll: 1,
                arrows: true,
                dots: false
           }
        },
        {
            breakpoint: 520,
            settings: {
                slidesToShow: 1.1,
                slidesToScroll: 1,
                arrows: false,
                dots: false
           }
        }
        ]
    });
    $(window).on('resize', function() {
        $('.js-slide-game').slick('resize');
    });
});






// WEBPACK FOOTER //
// ./src/js/pages/index/slide-game.js